import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../tailwind.css';
import App from './app/App';
import { StartupBoundary } from './app/StartupBoundary';
import './app/global.css';
import { applyDocumentLocale } from './locales/documentLocale';
import { loadLocale } from './locales/messages';
import { useLocaleStore } from './stores/localeStore';

dayjs.extend(relativeTime);

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root element was not found.');
}

function bootstrap(container: HTMLElement, failed = false) {
  createRoot(container).render(
    <StrictMode>
      <StartupBoundary failed={failed}>
        <App />
      </StartupBoundary>
    </StrictMode>,
  );
}

// Keep the existing HTML startup skeleton until the saved language is ready.
const locale = useLocaleStore.getState().locale;
applyDocumentLocale(locale);
void loadLocale(locale).then(
  () => bootstrap(root),
  (error: unknown) => {
    console.error('[LocaleStartup]', error);
    bootstrap(root, true);
  },
);
